<template>
  <v-card class="hc__rounded-card">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs10>
          <p class="title ma-0 hc__blue-text">Caso #{{ ticket.id}}</p>
          <p class="mt-2 mb-0"> Categoría: {{ ticket.category }}</p>
          <p class="mt-2 mb-0"> Fecha creación: {{ ticket.created_at }}</p>
          <p class="mt-1"> 
            Estado: 
            <span :class="`ma-0 ml-2 ${statusColor(ticket.status)}`">
              <v-icon :class="statusColor(ticket.status)">{{ statusIcon(ticket.status) }}</v-icon>
              {{ ticket.status }}
            </span>
          </p>

          <p class="mt-2 mb-0"> Descripción:</p>
          <p class="mt-0">{{ ticket.description }}</p>

          <v-btn color="warning" @click="showAlert()" v-if="!ticket.closed_at">
            Marcar como resuelto
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import Swal from "sweetalert2"

export default {
  props: {
    ticket: { type: Object, required: true },
    getTicket: { type: Function, required: true },
  },
  methods: {
    ...mapActions("helpcenter", ["closeTicket"]),
    statusColor(status) {
      if (status === "Creado") return "hc__color-open"
      else if (status === "En atención") return "hc__color-attended"
      else return "hc__color-close"
    },
    statusIcon(status) {
      if (status === "Creado") return "history"
      else if (status === "En atención") return "cached"
      else return "done"
    },
    async handleCloseTicket() {
      const res = await this.closeTicket(this.ticket.id)
      if (res.success) this.getTicket()
    },
    showAlert() {
      Swal.fire({ 
        title: "¿Estás seguro(a) de cerrar este caso?",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) this.handleCloseTicket()
      })
    }
  },
}
</script>
<style lang="">
  
</style>